export default __webpack_public_path__ + "static/lp-hero-a367a17050a23e190bb3df677db58bab.webp";